import { z } from 'zod'
import { platformShortcodeSchema } from '@/types/schema/platform/platform-shortcode-schema'

const parseLinksRequestSchema = z.object({
  urls: z.array(z.string()),
})
export type ParseLinksRequest = z.infer<typeof parseLinksRequestSchema>

const parsedLinkSchema = z.discriminatedUnion('status', [
  z.object({
    status: z.literal('success'),
    kol_info: z.object({
      uuid: z.string(),
      kol_name: z.string(),
    }),
    link: z.string(),
    platform_type: platformShortcodeSchema,
  }),
  z.object({
    status: z.enum(['need-create', 'failure']),
    link: z.string(),
  }),
])
export type ParsedLink = z.infer<typeof parsedLinkSchema>

export const parseLinksResponseSchema = z.object({
  data: parsedLinkSchema.array(),
})
export type ParseLinksResponse = z.infer<typeof parseLinksResponseSchema>
